exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Payments_emptyMessage_dgq8 {\n  text-align: center;\n}\n\n.Payments_button_wN3U {\n  margin-top: 20px;\n  padding-top: 20px;\n\n  text-align: center;\n\n  border-top: 1px solid #e6e6e6;\n}\n", ""]);

// exports
exports.locals = {
	"emptyMessage": "Payments_emptyMessage_dgq8",
	"button": "Payments_button_wN3U"
};